// extracted by mini-css-extract-plugin
module.exports = {"sortCriteria":"XoonipsListItem_sortCriteria__1qMi1","pageNavi":"XoonipsListItem_pageNavi__11_PU","pageNaviItem":"XoonipsListItem_pageNaviItem__1DI_t"};